import { Component, Inject } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { UploadDialog } from '../upload-dailog.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-zoho-links',
  templateUrl: './zoho-links.component.html',
  styleUrls: ['./zoho-links.component.css']
})
export class ZohoLinksComponent {

  buttonClicked = false;
  success = false;
  status;
  sheetNames;

  zoho = {
    client: null as any,
    sheetName: null as any,
    xl: null as any,
  };

  constructor( private api: ApiService, private snackbar: MatSnackBar, private _bottomSheet: MatBottomSheet, private jwt: JwtService, private mixpanel: MixpanelService, private sanitizer: DomSanitizer, private dialog: MatDialog ) { }

  clients = JSON.parse(sessionStorage.getItem('clients'));
  resp = [] as any;

  ngOnInit(): void {
    this.mixpanel.track("page_view", { page: "Zoho Links", category: "Dashboard", button: "-"  })
    this.jwt.check();
    this.zoho.sheetName = localStorage.getItem("zoho-xl");
  }

  upload( status : boolean ) {
    this.status = status;
    const formData = new FormData();
    formData.append('sheetName', this.zoho.sheetName );
    formData.append('client', this.zoho.client );
    formData.append('excelFile', this.zoho.xl );
    if( status ) {
      const dialogRef = this.dialog.open(UploadDialog);
      dialogRef.afterClosed().subscribe(result => {
        if ( result) {
          this.buttonClicked = true;
          this.mixpanel.track("button_click", { page: "Zoho Links", category: "Dashboard", button: "Upload" })
          formData.append('commit', 'yes');
          this.apiCall( formData);
        }
        else {
          //pass
        }
      })
    } else {
      this.buttonClicked = true;
      this.mixpanel.track("button_click", { page: "Zoho Links", category: "Dashboard", button: "Verify" });
      this.apiCall( formData);
    }
  }

  apiCall( formData ){
    this.api
      .zoho( formData )
      .subscribe( (data: any) => {
        this.buttonClicked = false;
        this.success = true;
        if ( data.data.length > 0){
          this.resp = this.sanitizer.bypassSecurityTrustHtml(data.data.join(""));
        } else {
          this.resp = null;
        }
        this.response( false );
        if (data.status) {
          this.snackbar.open( data.message, undefined , {
            duration: 5000,
            panelClass: 'success'
          });
        } else {
          this.snackbar.open( data.message, undefined , {
            duration: 5000,
            panelClass: 'failure'
          });
        }
      },
      ( error ) => {
        this.buttonClicked = false;
      });
  }

  remove_xl(){
    this.zoho.xl = null;
    this.sheetNames = null;
  }

  onFileSelected(event: any): void {
    this.zoho.xl = event.target.files[0] ?? null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {  const workbook = XLSX.read(e.target.result, { type: 'array' });
     this.sheetNames = workbook.SheetNames;
    };
    fileReader.readAsArrayBuffer(this.zoho.xl);
  }

  response( status ) {
    if (status) {
      this.mixpanel.track("button_click", { page: "Zoho Links", category: "Dashboard", button: "View Log" })
    }
    if (this.resp != null) {
      this._bottomSheet.open( ZohoLinksResponse, { data: this.resp });
    }
  }

  sheetName() {
    localStorage.setItem("zoho-xl", this.zoho.sheetName);
  }

}

@Component({
  selector: 'zoho-response',
  templateUrl: '../micro-learning-content/microLearning-response.html',
})
export class ZohoLinksResponse {
  constructor(private _bottomSheetRef: MatBottomSheetRef<ZohoLinksComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: []) {}
}
